import { render, staticRenderFns } from "./BunkerSummaryChart.vue?vue&type=template&id=a8a205fe&scoped=true"
import script from "./BunkerSummaryChart.vue?vue&type=script&lang=js"
export * from "./BunkerSummaryChart.vue?vue&type=script&lang=js"
import style0 from "./BunkerSummaryChart.vue?vue&type=style&index=0&id=a8a205fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a205fe",
  null
  
)

export default component.exports